import React from 'react';

import './styles.css';

const Tag = ({ title, className }) => {
  return (
    <div className={`wa-tag ${className}`}>
      <p>{title}</p>
    </div>
  );
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/ui/Tag/index.js